// Typeahead experiments
export const HA_TYPEAHEAD_LID_SEARCH = 'HA_TYPEAHEAD_LID_SEARCH';
export const VRBO_LANDING_EGUAS_TYPEAHEAD = 'VRBO_LANDING_EGUAS_typeahead';
